import { styled } from '@mui/material/styles';
import { ActionButton } from '@/components/buttons';

export const ActionsButtonStyled = styled(ActionButton)({
  marginBottom: '10px',
});
